import { type VariantProps } from "class-variance-authority"
import { type ButtonHTMLAttributes, forwardRef } from "react"

import { buttonVariants } from "./button-variants"
import { cn } from "./cn"

/**
 * The button, in the four variants this product uses.
 *
 * There is no `asChild`: a router `<Link>` that should look like a button takes
 * `className={buttonVariants({ variant: "primary" })}` instead. One fewer
 * dependency, and a link stays a link for a screen reader.
 */

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
	VariantProps<typeof buttonVariants>

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function ButtonImpl(
	{ className, variant, size, type = "button", ...props },
	ref,
) {
	return (
		<button
			ref={ref}
			type={type}
			className={cn(buttonVariants({ variant, size }), className)}
			{...props}
		/>
	)
})

// forwardRef names a component from its inner function, and those are now
// <name>Impl so they do not shadow the consts they are assigned to. These
// keep React DevTools showing the name the code actually uses.
Button.displayName = "Button"
